import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, Aree, ModelNumStr } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class AreeService extends CrudGenericsService<Aree, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Aree`);
    this.base = `${env.apiUrl}/api/Aree/`;
  }
  Get4Select_ByDiv(div: number): Observable<ModelNumStr[]> {
    const u = this.base + 'Get4Select_ByDiv?div=' + div;
    return this.http.get<ModelNumStr[]>(`${u}`);
  }
}
